/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ScholarshipResponse
 */
export interface ScholarshipResponse {
    /**
     * 
     * @type {string}
     * @memberof ScholarshipResponse
     */
    typeOther?: string;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof ScholarshipResponse
     */
    attachments?: Array<Attachment>;
    /**
     * 
     * @type {Option}
     * @memberof ScholarshipResponse
     */
    type?: Option;
    /**
     * 
     * @type {Option}
     * @memberof ScholarshipResponse
     */
    status?: Option;
}

export function ScholarshipResponseFromJSON(json: any): ScholarshipResponse {
    return ScholarshipResponseFromJSONTyped(json, false);
}

export function ScholarshipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScholarshipResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'typeOther': !exists(json, 'typeOther') ? undefined : json['typeOther'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(AttachmentFromJSON)),
        'type': !exists(json, 'type') ? undefined : OptionFromJSON(json['type']),
        'status': !exists(json, 'status') ? undefined : OptionFromJSON(json['status']),
    };
}

export function ScholarshipResponseToJSON(value?: ScholarshipResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'typeOther': value.typeOther,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(AttachmentToJSON)),
        'type': OptionToJSON(value.type),
        'status': OptionToJSON(value.status),
    };
}


